import React from 'react';
import s from './index.module.css';

import { getIsDevEnv, getIsMobile, getIsTestingEnv, getIsUserAuthenticated } from '../../../store/selectors';

import Orders from '../../Orders';
import Benefits from '../../Benefits';
import { ReactComponent as EmexSmallLogo } from '../../../assets/icons/EmexSmallLogo.svg';
import {
    getBuyerId,
    getCurrentDialogId,
    getSenderId,
    getVisitorId,
} from '../../../store/selectors';

import { useSelector } from 'react-redux';

const EMEX_USER_ACCOUNT_LINK_PROD = 'https://emex.ru/inmotion';
const EMEX_USER_ACCOUNT_LINK_TEST = 'https://test6.emex.ru/inmotion';

const OrdersInfoDisclamer = () => {
    const isTestingEnv = useSelector(getIsTestingEnv);
    const isDevEnv = useSelector(getIsDevEnv);
    const emexLink = <a
        href={isTestingEnv || isDevEnv
            ? EMEX_USER_ACCOUNT_LINK_TEST
            : EMEX_USER_ACCOUNT_LINK_PROD}
        target='_blank'
        rel='noopener noreferrer'
        className={s.userAccountLink}>личный кабинет</a>;

    return (
        <div className={s.userAccountDisclamer}>
            <div className={s.emexLogo}>
                <EmexSmallLogo />
            </div>
            <div className={s.disclamerDescription}>
                Для получения информации о заказах, оформленных на сайте <strong>emex.ru</strong> перейдите в свой {emexLink}
            </div>
        </div>
    )
};

const LayoutRight = ({ className }) => {
    const isMobile = useSelector(getIsMobile);
    const visitorId = useSelector(getVisitorId);
    const buyerId = useSelector(getBuyerId);
    const senderId = useSelector(getSenderId);
    const currentDialogIdd = useSelector(getCurrentDialogId);
    const isDevEnv = useSelector(getIsDevEnv);
    const { dialogId } = useSelector((state) => state.meta.user);
    const isAuthenticated = useSelector(getIsUserAuthenticated);

    const idsTable = (
        <table>
            <tbody>
                <tr>
                    <td className={s.testUI1}>{`senderId`}</td>
                    <td className={s.testUI1}>{`visitorId`}</td>
                    <td className={s.testUI1}>{`dialogId`}</td>
                    <td className={s.testUI1}>{`buyerId`}</td>
                    <td className={s.testUI1}>{`currentDialogId`}</td>
                </tr>
                <tr>
                    <td className={s.testUI2}>{senderId}</td>
                    <td className={s.testUI2}>{visitorId}</td>
                    <td className={s.testUI2}>{dialogId}</td>
                    <td className={s.testUI2}>{buyerId}</td>
                    <td className={s.testUI2}>{currentDialogIdd}</td>
                </tr>
            </tbody>
        </table>
    );

    return (
        <div className={className}>
            <div className={s.rightSideInfo}>
                {isDevEnv ? idsTable : null}
                {
                    isAuthenticated
                        ? <Orders />
                        : <div className={s.unauthorizedUserNotification}>
                            {isMobile
                                ? null
                                : <div className={s.benefitsHeader}>{[0, 1, 2].map((key) => <div key={key} className={s.pointer} />)}</div>}
                            <Benefits />
                        </div>
                }
                <OrdersInfoDisclamer />
            </div>
        </div>
    )
};

export default LayoutRight;

